// extracted by mini-css-extract-plugin
module.exports = {"container":"member_container__iTMJO","avatar":"member_avatar__vlxQX","name":"member_name__q7GCd","position":"member_position__M6J2x","tooltip":"member_tooltip__iuYQW"};